module.exports = __webpack_public_path__ + "static/media/comment-times.46f20637.svg";